"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FormQuestionType_1 = __importDefault(require("../FormQuestionType"));
const getOptionsFromConfig = (questionType, rule) => {
    if (!rule)
        return [];
    switch (questionType) {
        case FormQuestionType_1.default.CHECK: {
            const config = rule;
            return [config.yes, config.no];
        }
        case FormQuestionType_1.default.RATING: {
            const config = rule;
            return [config.rating0, config.rating1, config.rating2, config.rating3, config.rating4];
        }
        case FormQuestionType_1.default.LIST: {
            const config = rule;
            return config.options;
        }
        case FormQuestionType_1.default.NUMBER: {
            const config = rule;
            return [config.lessThan, config.moreThan];
        }
        default:
            return [];
    }
};
exports.default = getOptionsFromConfig;
